module.exports = __webpack_public_path__ + "img/GH-kyujin-top-001.f7ab54fa.webp";